import Environment from "../Environment/Environment";
import Http from "../Http/Http";
import Constants from "../Action/Constants";
import Store from "../Store/Store";

class Version {

  private interval: any;
  public version: number = Environment.getBuildDate();
  private loop: number = 1000 * 60 * 5; // 5 min

  public listen(shouldSkipListenNow?): void {
    // We don't need to refresh browser if it is rendered by webpack.
    if (Environment.isRenderedByWebpack() === true) {
      return;
    }

    // shouldSkipListenNow === true when user click no on update version window
    if(!shouldSkipListenNow) {
      // Otherwise, we have to listen for version changes on backend and show indicator to user.
      this.checkNewVersion();
    }

    this.interval = setInterval(() => {
      this.checkNewVersion();
    }, this.loop);
  }

  public checkNewVersion(): any {
    this.getFrontendVersion().then(date => {
      if (date !== this.version) {
        Store.getConfigurator().dispatch({
          type: Constants.NEW_VERSION_AVAILABLE
        });

        clearInterval(this.interval);
      } else {
        Store.getConfigurator().dispatch({
          type: Constants.NEW_VERSION_IGNORE
        });
      }
    });
  }

  public getFrontendVersion(): Promise<any> {
    return Http.get("version", {}, false)
    .then(res => {
      return res.data.date;
    });
  }
}

export default new Version();
